var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"iconfont",style:(_vm.styles),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#icon${_vm.type}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }